import React from 'react';
import {Formik} from 'formik';
import {useSearchParams} from 'react-router-dom';
import Preview3DComponent from 'components/customer/Preview3D/components/Preview3DComponent';
import {useProductPreviewItem} from 'components/customer/Preview3D/hooks/useProductPreviewItem';
import {SlugQueryParams} from 'components/customer/Preview3D/types';
import {ProductDataStore} from 'components/customer/Preview3D/usePreview3DData';
import {JobCabinet} from 'components/customer/Job/store/jobApi';
import ViewRoomPlanner from 'components/customer/Preview3D/components/ViewRoomPlanner';

const StandalonePreview3D = ({slug}: SlugQueryParams) => {
    const {initialValues, formSchema, productDataStore, productInfo} =
        useProductPreviewItem({
            slug,
        }) as {
            initialValues: object;
            formSchema: object;
            productDataStore: ProductDataStore;
            productInfo: unknown;
        };
    const [query] = useSearchParams();
    const view = query.get('view');

    if (
        !initialValues ||
        !formSchema ||
        Object.keys(formSchema).length == 0 ||
        Object.keys(initialValues).length == 0
    ) {
        return null;
    }

    const link3DRP = (productInfo as JobCabinet)['3DRoomURL'];

    return (
        <>
            <Formik
                enableReinitialize={true}
                validationSchema={formSchema}
                initialValues={{
                    ...initialValues,
                }}
                onSubmit={undefined}>
                <form noValidate onSubmit={undefined}>
                    <Preview3DComponent
                        isStandalonePreview={true}
                        previewLocation={'SPECS'}
                        fullScreen
                        raw={view?.toLowerCase() == 'raw'}
                        product={initialValues}
                        productDataStore={productDataStore}
                    />
                </form>
            </Formik>
            {view?.toLowerCase() !== 'raw' && !!link3DRP ? (
                <ViewRoomPlanner link3DRP={link3DRP} />
            ) : null}
        </>
    );
};

export default StandalonePreview3D;
